import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newModelosProductosSchema } from '@/shared';
import {
  useCreateModeloProduct,
  useUpdateModeloProduct,
} from '@/shared/actions/erp';

import {
  SingleFormBoxScene,
  SampleCheckbox,
  CustomTextField,
} from '@/shared/components/ui';
import { MODELOPRODUCTOS } from '@/shared/interfaces/erp/inventario';



const returnUrlModeloProductos = '/inventario/modelo-productos';

export interface SaveModeloProductosInterface {
  titlePage: string;
  editModeloProducto?: MODELOPRODUCTOS;
}

type SaveFormData = {
  nombre: string;
  estado: boolean;
};

const SaveModeloProductos: React.FC<SaveModeloProductosInterface> = ({ titlePage, editModeloProducto }) => {
  const navigate = useNavigate();
  ///* local state
  const [shrink, setShrink] = useState(false);


  ///* mutations
  const createModeloProductMutation = useCreateModeloProduct({ navigate, returnUrl: returnUrlModeloProductos });
  const updateModeloProductMutation = useUpdateModeloProduct({ navigate, returnUrl: returnUrlModeloProductos });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newModelosProductosSchema),
    defaultValues: { estado: false },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editModeloProducto?.id_modelo) {
      return updateModeloProductMutation.mutate({
        id: editModeloProducto.id_modelo,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createModeloProductMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editModeloProducto) {
      setShrink(true);
      reset({
        ...editModeloProducto
      } as any);
    }
  }, [editModeloProducto]);
  ///*fetch


  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlModeloProductos);
      }}
      onSave={handleSubmit(onSave)}
    >
      
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />

      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveModeloProductos;
